module.exports = __webpack_public_path__ + "static/media/ic-drawer-menu-management.bc0eec11.svg";